export default __webpack_public_path__ + "static/media/access_control_locations_icons_corporate_factory.7644b3a4.svg";